import type { PositioningLane } from '../../../../src/commonTypes';

export const positioningProblemKey = 'problem';

export const positioningHubKey = (lane: PositioningLane): string => `hub-${lane}`;

export const positioningAddKey = (lane: PositioningLane): string => `add-${lane}`;

export const positioningCardKey = (sourceOutputId: string): string => `card:${sourceOutputId}`;
